import { Navigate, useParams } from "react-router"
import { useDealerAppRoutes } from "src/common/routes/useDealerAppRoutes"

// vehicleDetails used to live at a flat top-level /vehicle/:vehicleKey/... URL (e.g. /vehicle/:vehicleKey/details/overview,
// /vehicle/:vehicleKey/sell) before it moved to /inventory/:vehicleKey/... nested under inventoryList. This keeps old
// bookmarked/shared links working by mapping the legacy path shape onto the new one.
export const LegacyVehicleDetailsRedirect = () => {
	const { "*": rest, vehicleKey } = useParams<{ "*": string; vehicleKey: string }>()
	const routes = useDealerAppRoutes()

	if (!vehicleKey || !routes?.inventoryList?.vehicleDetails) {
		return null
	}

	const segments = (rest ?? "").split("/").filter(Boolean)
	if (segments[0] === "details") {
		segments.shift()
	}
	if (segments[0] === "overview") {
		segments.shift()
	}
	const suffix = segments.length > 0 ? `/${segments.join("/")}` : ""

	return <Navigate to={`${routes.inventoryList.vehicleDetails.url(vehicleKey)}${suffix}`} replace />
}
